import { verifyStock } from "../../../services";

const sproutz_url = process.env.REACT_APP_SPROUTZ_VERIFYSTOCK;

export const stock = async (props) => {
  const {
    cart,
    setCart,
    tillData,
    setProductStock,
    isFinalValidation,
    setTempCart,
    isCompleteSale,
    setShowCompleteSaleStock,
    setCompleteSaleStockData,
    customMixHandler = false,
    setProductBOMStock,
    setProductBOMStockData,
  } = props;
  const isAdvanceOrder = localStorage.getItem("isAdvanceOrder") === "Y";
  const consolidateCart = (cart) => {
    const flatItems = [];

    cart.items.forEach((item) => {
      if (item.productSegment === "CB") {
        if (Array.isArray(item.childItems) && item.childItems.length > 0) {
          item.childItems.forEach((child) => {
            flatItems.push({
              ...child,
              parentLineId: item.lineId,
              type: child?.type,
              weight: child.weight,
              mBatchId: child.mBatchId || null,
              csBunitId: item.csBunitId || null,
              cwrPcatalogueId: item.cwrPcatalogueId || null,
            });
          });
        }
      } else if (Array.isArray(item.addons) && item.addons.length > 0) {
        item.addons.forEach((addon) => {
          flatItems.push({
            ...addon,
            parentLineId: item.lineId,
            type: "I",
            weight: addon.qty,
            mBatchId: addon.mBatchId || null,
            csBunitId: item.csBunitId || null,
            cwrPcatalogueId: item.cwrPcatalogueId || null,
          });
        });
      } else if (Array.isArray(item.children) && item.children.length > 0) {
        item.children.forEach((child) => {
          flatItems.push({ ...child, parentLineId: item.lineId }); // Track parent
        });
      } else {
        flatItems.push(item);
      }
    });
    // const itemsMap = new Map();
    // flatItems.forEach((item) => {
    //   const uniqueKey = `${item.value}_${item.mBatchId}`;
    //   if (itemsMap.has(uniqueKey)) {
    //     // Add weight to the existing entry
    //     itemsMap.get(uniqueKey).weight += item.weight;
    //   } else {
    //     // Add a new entry
    //     itemsMap.set(uniqueKey, { ...item });
    //   }
    // });
    // let consolidatedItems = Array.from(itemsMap.values());
    // const result = consolidatedItems.filter((item) => {
    //   if (item?.productSegment !== "CB") {
    //     return item;
    //   }
    // });
    const consolidatedItems = flatItems.map((item) => ({
      ...item,
      weight: Number(item.weight || 0),
    }));
    return { ...cart, items: consolidatedItems };
  };
  const getProductNameById = (productId) => {
    for (const item of cart.items) {
      if (item.value === productId) {
        return item.name || "";
      }

      if (Array.isArray(item.children)) {
        for (const child of item.children) {
          if (child.value === productId) {
            return child.name || " ";
          }
        }
      }

      if (Array.isArray(item.childItems)) {
        for (const child of item.childItems) {
          if (child.value === productId) {
            return child.name || " ";
          }
        }
      }

      if (Array.isArray(item.addons)) {
        for (const addon of item.addons) {
          if (addon.value === productId) return addon.name || "";
        }
      }
    }
    return " ";
  };

  const cleanedCart = consolidateCart(cart);
  // const buildCartProducts = cleanedCart.items
  //   .map(({ value, weight, mBatchId, csBunitId, cwrPcatalogueId }) => {
  //     if (sproutz_url === "true") {
  //       return `{ productId: "${value}",,mBatchId: ${mBatchId ? `"${mBatchId}"` : null}, orderQty: ${weight}, cSBunitID: ${csBunitId ? `"${csBunitId}"` : null}, catalogueId: ${
  //         cwrPcatalogueId ? `"${cwrPcatalogueId}"` : null
  //       }   }`;
  //     } else {
  //       return `{ productId: "${value}",,mBatchId: ${mBatchId ? `"${mBatchId}"` : null}, orderQty: ${weight}, cSBunitID: ${csBunitId ? `"${csBunitId}"` : null}  }`;
  //     }
  //   })
  //   .join(", ");
  const consolidatedCartItems = new Map();

  cleanedCart.items.forEach((item) => {
    const { value, weight, mBatchId, csBunitId, cwrPcatalogueId, alternateUom, uom, uomData } = item;

    let calculatedQty = Number(weight || 0);

    const selectedAlternateUom = Array.isArray(alternateUom) ? alternateUom.find((altUom) => altUom?.csUomId && uom && altUom.csUomId === uom) : null;

    if (selectedAlternateUom) {
      const conversionRate = Number(selectedAlternateUom?.convertionRate ?? 1);

      const matchedUomData = Array.isArray(uomData) ? uomData.find((uomItem) => uomItem?.csUomId === uom) : null;

      // const stdprecision = Number(matchedUomData?.stdprecision ?? 3);

      calculatedQty = Number(weight || 0) * (Number.isNaN(conversionRate) ? 1 : conversionRate);

      calculatedQty = Number(calculatedQty.toFixed(3));
    }

    const uniqueKey = `${value}_${mBatchId}`;

    if (consolidatedCartItems.has(uniqueKey)) {
      const existingItem = consolidatedCartItems.get(uniqueKey);

      existingItem.orderQty = Number(existingItem.orderQty || 0) + calculatedQty;

      consolidatedCartItems.set(uniqueKey, existingItem);
    } else {
      consolidatedCartItems.set(uniqueKey, {
        productId: value,
        mBatchId,
        orderQty: calculatedQty,
        csBunitId,
        cwrPcatalogueId,
      });
    }
  });

  const buildCartProducts = Array.from(consolidatedCartItems.values())
    .map(({ productId, orderQty, mBatchId, csBunitId, cwrPcatalogueId }) => {
      if (sproutz_url === "true") {
        return `{ productId: "${productId}",,mBatchId: ${mBatchId ? `"${mBatchId}"` : null}, orderQty: ${orderQty}, cSBunitID: ${
          csBunitId ? `"${csBunitId}"` : null
        }, catalogueId: ${cwrPcatalogueId ? `"${cwrPcatalogueId}"` : null} }`;
      } else {
        return `{ productId: "${productId}",,mBatchId: ${mBatchId ? `"${mBatchId}"` : null}, orderQty: ${orderQty}, cSBunitID: ${csBunitId ? `"${csBunitId}"` : null} }`;
      }
    })
    .join(", ");
  const data = {
    query:
      sproutz_url === "true"
        ? `
        query { 
          verifyStock1(order: {
            orderNo: "${cart.documentno}"
            tillId: "${tillData.tillAccess.cwrTill.searchKey}"
            cartItems: [${buildCartProducts}]
          }) {
            orderNo
            tillId
            cartItems {
              productId
              orderQty
              mBatchId
              availabilityStatus
              availableQty
            }
          }
        }
      `
        : `
        query { 
          verifyStock(order: {
            orderNo: "${cart.documentno}"
            tillId: "${tillData.tillAccess.cwrTill.searchKey}"
            cartItems: [${buildCartProducts}]
          }) {
            orderNo
            tillId
            cartItems {
              productId
              orderQty
              mBatchId
              availabilityStatus
              availableQty
              billOfMaterials{
                value
                qtyOnHand
              }
            }
          }
        }
      `,
  };
  try {
    const isAdvanceOrderEnabled = localStorage.getItem("isAdvanceOrderEnabled") === "true";
    if (isAdvanceOrderEnabled) {
      return true;
    }
    const response = await verifyStock(data);
    if (response.status === 200) {
      const { cartItems } = sproutz_url === "true" ? response.data.data.verifyStock1 : response.data.data.verifyStock;
      const posConfig = JSON.parse(localStorage.getItem("posConfig"));

      let totalFlag = true;
      const updateCartItems = (item) => {
        const resItem = cartItems.find((resItem) => resItem.productId === item.value && (item.mBatchId ? resItem.mBatchId === item.mBatchId : true));
        if (!resItem) return item;
        if (resItem.availabilityStatus !== "Yes" && resItem.availableQty < item.weight) {
          totalFlag = false;
        } else if (resItem.availabilityStatus !== "Yes") {
          resItem.availableQty -= item.weight;
        }
        return {
          ...item,
          availabilityStatus: resItem.availabilityStatus,
          availableQty: resItem.availableQty,
        };
      };
      if (isFinalValidation) {
        const updatedCartData = cart.items.map(updateCartItems);
        const updatedCartItems = [];

        const groupedByParent = {};

        updatedCartData.forEach((item) => {
          if (item.childrenId) {
            if (!groupedByParent[item.childrenId]) {
              groupedByParent[item.childrenId] = [];
            }
            groupedByParent[item.childrenId].push(item);
          } else {
            updatedCartItems.push(item); // normal item
          }
        });

        // Merge children back into their parent items
        cart.items.forEach((originalItem) => {
          const lineId = originalItem.lineId;
          if (groupedByParent[lineId]) {
            updatedCartItems.push({
              ...originalItem,
              children: groupedByParent[lineId],
            });
          } else if (originalItem.productSegment === "CB" && Array.isArray(originalItem.childItems)) {
            const updatedChildren = originalItem.childItems.map((child) => {
              return updatedCartData.find((item) => item.value === child.value && (child.mBatchId ? item.mBatchId === child.mBatchId : true)) || child;
            });

            updatedCartItems.push({
              ...originalItem,
              childItems: updatedChildren,
            });
          }
        });
        const updatedCart = { ...cart, items: updatedCartData };
        setCart(updatedCart);
        localStorage.setItem("cartObj", JSON.stringify(updatedCart));
        setTempCart(JSON.parse(JSON.stringify(updatedCart)));
        return totalFlag;
      } else {
        // const checkItemStock = (item) => {
        //   const resItem = cartItems.find((resItem) => resItem?.productId === item?.value && item?.type === "I" && (item.mBatchId ? resItem.mBatchId === item.mBatchId : true));

        //   if (resItem && resItem.availabilityStatus !== "Yes") {
        //     if (resItem.availableQty < item.weight) return true;
        //     resItem.availableQty -= item.weight;
        //   }

        //   return false;
        // };

        const getCalculatedQty = (item) => {
          const { weight, alternateUom, uom, uomData } = item;

          let calculatedQty = Number(weight || 0);

          const selectedAlternateUom = Array.isArray(alternateUom) ? alternateUom.find((altUom) => altUom?.csUomId && uom && altUom.csUomId === uom) : null;

          if (selectedAlternateUom) {
            const conversionRate = Number(selectedAlternateUom?.convertionRate ?? 1);

            const matchedUomData = Array.isArray(uomData) ? uomData.find((uomItem) => uomItem?.csUomId === uom) : null;

            // const stdprecision = Number(matchedUomData?.stdprecision ?? 3);

            calculatedQty = Number(weight || 0) * (Number.isNaN(conversionRate) ? 1 : conversionRate);

            calculatedQty = Number(calculatedQty.toFixed(3));
          }

          return calculatedQty;
        };

        const checkItemStock = (item) => {
          const resItem = cartItems.find((resItem) => resItem?.productId === item?.value && item?.type === "I" && (item.mBatchId ? resItem.mBatchId === item.mBatchId : true));

          if (resItem && resItem.availabilityStatus !== "Yes") {
            const calculatedQty = getCalculatedQty(item);

            if (resItem.availableQty < calculatedQty) {
              return true;
            }

            resItem.availableQty -= calculatedQty;
          }

          return false;
        };

        // const hasInsufficientStock = cart.items.some((item) => {
        //   if (checkItemStock(item)) return true;
        //   if (Array.isArray(item.children)) {
        //     return item.children.some(checkItemStock);
        //   }

        //   return false;
        // });

        const hasInsufficientStock = cleanedCart.items.some(checkItemStock);

        if (hasInsufficientStock && tillData.tillAccess.csBunit.allowNegativeStock === "N") {
          if (!customMixHandler) {
            if (isCompleteSale) {
              const stockDetails = cartItems.map((item) => ({
                ...item,
                name: getProductNameById(item.productId),
              }));
              setCompleteSaleStockData(stockDetails);
              setShowCompleteSaleStock(true);
            } else {
              const stockDetails = posConfig?.requireBomStock === "Y" ? cartItems.filter((item) => item.billOfMaterials && item.billOfMaterials.length > 0) : [];

              setProductBOMStockData(stockDetails);

              if (posConfig?.requireBomStock === "Y" && stockDetails.length > 0) {
                setProductBOMStock(true);
              } else {
                setProductBOMStock(false); // hide drawer if no BOM stock issues
                setProductStock(true);
              }
            }
          }
          return false;
        }
      }
      return true;
    }
  } catch (error) {
    console.error("Error checking stock:", error);
    return false;
  }
};
